// APIs for the public campaign page. These are served on the short url host and identify the visitor through the session.

async function request(path, { method = "GET", body } = {}, fallbackError) {
  try {
    const options = { method }
    if (body !== undefined) {
      options.headers = { "Content-Type": "application/json" }
      options.body = JSON.stringify(body)
    }
    const res = await fetch(`/api/public/campaigns/${path}`, options)
    const data = await res.json()
    if (res.status >= 400) {
      return { error: data.Error || fallbackError, status: res.status }
    }
    return { data: data.Data }
  } catch (e) {
    console.error(fallbackError, e)
    return { error: fallbackError }
  }
}

export async function fetchPublicCampaign({ campaignToken }) {
  const { data, error, status } = await request(campaignToken, {}, "Error while fetching campaign. Please try again in sometime.")
  if (error) return { error, status }
  return { campaign: data }
}

export async function fetchPublicCampaignPosts({ campaignToken, tab, limit, offset }) {
  const queryParams = new URLSearchParams({ tab, limit, offset })
  const { data, error } = await request(`${campaignToken}/posts?${queryParams.toString()}`, {}, "Error while fetching posts. Please try again in sometime.")
  if (error) return { error }
  return { posts: data?.Posts || [] }
}

export async function loginPublicCampaign({ campaignToken }) {
  const { data, error } = await request(`${campaignToken}/login`, { method: "POST", body: {} }, "Error while signing in. Please try again in sometime.")
  if (error) return { error }
  return { loggedIn: data?.LoggedIn, oauthRedirectURL: data?.OAuthRedirectURL }
}

export async function sharePublicCampaignPost({ campaignToken, postID, variationID, postOverride }) {
  const { data, error } = await request(
    `${campaignToken}/posts/${postID}/share`,
    { method: "POST", body: { variationID, postOverride } },
    "Error while sharing post. Please try again in sometime.",
  )
  if (error) return { error }
  return { data }
}

export async function resumePublicCampaignShares({ campaignToken }) {
  const { data, error } = await request(`${campaignToken}/resume-share`, { method: "POST", body: {} }, "Error while sharing post. Please try again in sometime.")
  if (error) return { error }
  return { data }
}

export async function fetchPublicCampaignPostVariation({ campaignToken, postID, postVariationID }) {
  const { data, error } = await request(`${campaignToken}/posts/${postID}/post-variations/${postVariationID}`, {}, "Error while fetching post. Please try again in sometime.")
  if (error) return { error }
  return { variation: data }
}

// returns the raw response data like getMediaUploadUrl, so that the media uploader can use either
export async function getPublicCampaignMediaUploadUrl(files, campaignToken) {
  const { data, error } = await request(`${campaignToken}/media/presigned-url`, { method: "POST", body: { files } }, "Failed to get upload URL. Please try again.")
  if (error) return { error }
  return { Data: data }
}
